import React, { useEffect, useState } from "react";
import "./style.scss";
import image1 from "assets/cursos/1/1.jpg";
import image2 from "assets/cursos/2/2.jpg";
import image3 from "assets/cursos/3/3.jpg";
import image4 from "assets/cursos/4/4.jpg";
import image5 from "assets/cursos/5/5.jpg";
import image6 from "assets/cursos/6/6.jpg";
import { api } from "services/api";
import { useSelector } from "react-redux";
import { handleOpenTab, PORTAL_PUBLICO_BASE_URL } from 'utils';

export const AvailableCoursesPage: React.FC = () => {
	const [courses, setCourses] = useState<any[]>([]);
	const { id: userId } = useSelector((state: any) => state.app.user);
	const [courseFeedback, setCourseFeedback] = useState<any>();
	useEffect(() => {
		api.get(`/courses/to_user/${userId}`).then((result) => {
			const {
				data: {
					data: { courses },
					feedback,
				},
			} = result;
			setCourseFeedback(feedback);

			setCourses(courses);
		});
		// eslint-disable-next-line
	}, []);
	const imageArr = [image1, image2, image3, image4, image5, image6];
	return (
		<div className="available-courses">
			<div className="available-courses__container">
				<h1 className="available-courses__container__title">
					CURSOS DISPONÍVEIS
				</h1>
				<div className="available-courses__container__items">
					{courses.length !== 0 &&
						courses.map((item, index) => {
							return (
								<div
									key={index}
									className="available-courses__container__items__card"
									onClick={() =>
										handleOpenTab(PORTAL_PUBLICO_BASE_URL, "/course/", `${item.id}`)
									}
								>
									<div className="available-courses__container__items__card__img">
										<img
											src={item.image ? item.image : imageArr[index]}
											alt=""
											width="260px"
										/>
									</div>
									<div className="available-courses__container__items__card__info">
										<h1 className="available-courses__container__items__card__info__title">
											{item.title}
										</h1>
										<span className="available-courses__container__items__card__info__author">
											{item.author}
										</span>
										<p className="available-courses__container__items__card__info__description">
											{item.description.length > 284
												? `${item.description.substring(0, 284)}...`
												: item.description}
										</p>
										<p className="available-courses__container__items__card__info__subtitle">
											Classificação indicativa: 4 anos
										</p>
									</div>
									<div className="available-courses__container__items__card__info__tags">
										{item?.tags?.split(",")?.map((tag: any) => (
											<p className="tag">{tag}</p>
										))}
									</div>
								</div>
							);
						})}
					{courses.length === 0 && (
						<h1
							style={{
								fontSize: "30px",
								fontFamily: "Montserrat",
								fontWeight: "300",
							}}
						>
							{courseFeedback
								? courseFeedback["empty"]
								: "Sem cursos para exibir."}
						</h1>
					)}
				</div>
			</div>
		</div>
	);
};
